var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23922 1.63965H3.12845C2.27708 1.63965 1.58691 2.32982 1.58691 3.18119V7.29196M18.5438 1.63965H22.6546C23.506 1.63965 24.1961 2.32982 24.1961 3.18119V7.29196M1.58691 18.5966V22.7073C1.58691 23.5587 2.27708 24.2489 3.12845 24.2489H7.23922M24.1961 18.5966V22.7073C24.1961 23.5587 23.506 24.2489 22.6546 24.2489H18.5438M1.58691 12.7559H24.1961",
    stroke: "#329DFF",
    strokeWidth: 1.54154
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.99834a0389fd7f2e3cffbe268e0f24dc.svg";
export { ForwardRef as ReactComponent };